import React from 'react';

const Button = (props) => {
    return (
        <button {...props} className={`Button Button--primary ${props.className}`}>{props.text}{props.children}</button>
    )
}

export default Button;